/**
 * Pedir, desde cualquier pantalla, el cambio de sucursal que hace el selector de la cabecera. El cambio sigue pasando
 * por su diálogo con motivo (ADR-0003): aquí solo se le avisa al selector a dónde se quiere ir.
 */
export interface DestinoSucursal {
  id: string;
  nombre: string;
}

let atender: ((d: DestinoSucursal) => void) | null = null;

export function pedirCambioDeSucursal(d: DestinoSucursal) {
  atender?.(d);
}

/** Lo registra el selector de la cabecera mientras está montado. */
export function atenderCambioDeSucursal(f: ((d: DestinoSucursal) => void) | null) {
  atender = f;
}
